var map = {
	"./bijaksana_junerosano.jpg": 261,
	"./dewi_anjani.jpg": 262,
	"./najelaa_shihab.jpg": 263,
	"./paragon_segitiga.png": 264,
	"./widharmika_agung.jpg": 265
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1357;